// removed by extract-text-webpack-plugin
module.exports = {"booking-rating":"BookingRating_booking-rating---sb","bookingRating":"BookingRating_booking-rating---sb","rate":"BookingRating_rate---sb","numbered-rate":"BookingRating_numbered-rate---sb","numberedRate":"BookingRating_numbered-rate---sb","stared-rate":"BookingRating_stared-rate---sb","staredRate":"BookingRating_stared-rate---sb","subtitle":"BookingRating_subtitle---sb","rtl":"BookingRating_rtl---sb","mobile-view":"BookingRating_mobile-view---sb","mobileView":"BookingRating_mobile-view---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/BookingRating/styles.less
// module id = 1642
// module chunks = 0